import React from 'react';
import Image from 'components/Image';
import TutoringAnnouncementBanner from 'coaching/components/CoachingHomeView/TutoringAnnouncementBanner';
import CoachingConstants from 'coaching/CoachingConstants';

import CalendarDoodleIllustration from 'assets/images/coaching/calendar_doodle.svg';

export const Thanksgiving2021Banner = () => (
  <TutoringAnnouncementBanner
    figure={<Image src={CalendarDoodleIllustration} width={60} />}
    heading="We’re staying open on Thanksgiving!"
    copy="If you don’t plan to attend sessions scheduled on Thursday, November 25, remember to cancel or reschedule at least 24 hours in advance by selecting and editing the session in the list."
  />
);

export const Holiday2021Banner = () => (
  <TutoringAnnouncementBanner
    figure={<Image src={CalendarDoodleIllustration} width={60} />}
    heading="We’re closed for the holidays!"
    copy={
      <>
        As you may know, the holidays are right around the corner! We wanted to inform you all that
        Remind Tutoring will be closed on the following dates: 
        <br />
        <br />
        Christmas Eve - 12/24/21
        <br />
        Christmas Day - 12/25/21
        <br />
        New Year's Eve - 12/31/21
        <br />
        New Year's Day - 1/1/22
        <br />
        <br />
        If you have sessions that fall within these dates, your sessions will be automatically
        canceled. If you have any questions, please reach out to our support team through your
        Tutoring Dashboard.
      </>
    }
  />
);
